import { render, staticRenderFns } from "./MxModal.vue?vue&type=template&id=0ce7adae&"
import script from "./MxModal.vue?vue&type=script&lang=js&"
export * from "./MxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports